// @flow
import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import { Button } from "shared/formElements";
import { gaswechselUrl, stromwechselUrl } from "modules/MyShortOffers/misc/Routes";
import { isMobile } from "Commons/Utilities";

import Soeren from "Commons/Assets/images/Soeren.png";
import SoerenSignature from "Commons/Assets/images/Soerensignature.jpg";
import { ReactComponent as Phone } from "Commons/Assets/icons/phone.svg";
import { ReactComponent as WhatsApp } from "Commons/Assets/icons/whatsapp.svg";
import { ReactComponent as Email } from "Commons/Assets/icons/email.svg";
import { ReactComponent as ArrowRight } from "Commons/Assets/icons/Arrow_right.svg";

import Styles from "./AgentMessage.module.scss";

type Props = {
  offerExist: boolean,
  categoryName: string,
  savings: number,
};

const AgentMessage = ({ offerExist, categoryName, savings }: Props) => {
  const { t } = useTranslation("offerPageDetail");
  const title = offerExist
    ? t("hero.title", { categoryName: categoryName ? t(`categories:${categoryName}`) : "" })
    : t("noOffer.title");
  const messageI18nKey = offerExist ? (isMobile() ? "hero.shortDesc" : "hero.description") : "noOffer.description";
  const noSavingsTitle = t("noSavings.title");
  const noSavingsKey = "noSavings.description";
  const createOfferCategoryLink = categoryName === "strom" ? stromwechselUrl : gaswechselUrl;

  return (
    <div className={Styles.agentMessage}>
      <h4>{savings <= 0 ? noSavingsTitle : title}</h4>
      <div className={Styles.message}>
        <Trans t={t} i18nKey={savings <= 0 ? noSavingsKey : messageI18nKey}>
          <p />
        </Trans>
        <div className={Styles.signature}>
          <Trans t={t} i18nKey="hero.signature">
            <br />
          </Trans>
          <img src={SoerenSignature} alt="Sören Signature" />
        </div>
        {(!offerExist || savings <= 0) && (
          <Link className={Styles.ctaBtn} to={createOfferCategoryLink + "?utm_campaign=newofferafterempty"}>
            <Button>
              {t("noOffer.getNewOfferLink")}
              <ArrowRight className={Styles.buttonArrow} />
            </Button>
          </Link>
        )}
      </div>
      <div className={Styles.profile}>
        <img src={Soeren} alt="Sören Gruber" />
        <div className={Styles.signature}>
          <img src={SoerenSignature} alt="Sören Signature" />
          <h5>{t("hero.contactName")}</h5>
          <h6>{t("hero.contactTitle")}</h6>
        </div>
      </div>
      <div className={Styles.contact}>
        <a href={t("common:contactOptions.phoneCall")}>
          <Phone />
          <span>{t("common:contactOptions.phone")}</span>
        </a>
        <a href={t("common:contactOptions.whatsappCall")}>
          <WhatsApp />
          <span>{t("common:contactOptions.whatsappNumber")}</span>
        </a>
        <a href={t("common:contactOptions.emailCall")}>
          <Email />
          <span>{t("common:contactOptions.email")}</span>
        </a>
      </div>
    </div>
  );
};

export default AgentMessage;
